import {
  FormattedUnitLabels,
  PrecisionFormatterConfig,
} from '@/helpers/unit-formatter/shared/types';
import { formatNumber } from '@/helpers/unit-formatter/shared/utils';

/**
 * Generic formatter for the common case: format a number to `precision` decimals,
 * joined to the unit with a space (default) or no separator (`noSpace: true`, used
 * by degree, percent, and rate-per-kwh).
 *
 * Assumes `value` is already a finite number — the registry adapter guarantees this.
 */
export const createPrecisionFormatter =
  (config: PrecisionFormatterConfig) =>
  ({ value }: { value: number }): FormattedUnitLabels => {
    const prefix = config.unitPrefix ?? '';
    const suffix = config.unitSuffix ?? '';
    const formattedValue = formatNumber(value, config.precision);
    const numericLabel = formattedValue == null ? '' : String(formattedValue);
    const unitsLabel = `${prefix}${suffix}`;
    const prefixedValueLabel = `${prefix}${numericLabel}`;
    const unitSuffixLabel = suffix;

    const spacedSuffix = config.noSpace ? suffix : suffix ? ` ${suffix}` : '';
    const suffixedValueLabel = suffix ? `${numericLabel}${spacedSuffix}` : numericLabel;
    const valueUnitsLabel = `${prefixedValueLabel}${spacedSuffix}`;

    return {
      valueLabel: numericLabel,
      unitsLabel,
      prefixedValueLabel,
      unitSuffixLabel,
      suffixedValueLabel,
      valueUnitsLabel,
    };
  };
